export default __webpack_public_path__ + "static/media/11_1_1.f3a71fb6.png";